import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../views/Home.vue'

import user_module from "@/modules/user"

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Root',
    meta: {
      title: 'PDF Parser'
    },
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: 'PDF Parser'
    },
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      title: 'PDF Parser - Login'
    },
    component: () => import ('@/views/Login.vue')
  },
  {
    // path: '/file/:id',
    path: '/file',
    name: 'File',
    meta: {
      title: 'PDF Parser'
    },
    component: () => import ('@/views/File.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      title: 'PDF Parser'
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('CRM_Token')

  if (token === 'undefined' || !token) {

    if (to.path !== '/login') {
      next('/login')
    } else {
      next()
    }
  } else {

    if (!user_module.session_token) {

      
      try{

        const response = await user_module.userInit()
        if (!user_module.APPSTORE && user_module.Token && response){
  
          localStorage.setItem('AppToken', user_module.Token);
  
        }
  
        // @ts-ignore
        if (router.app.lexe) {
          // @ts-ignore
          router.app.lexe.authorization()
        }
  
        next()

      } catch(err){
        console.log('err', err);

        localStorage.removeItem('CRM_Token')
        next('/login');

      }
      

    } else {
      next()
    }
  }
})

export default router
